
























import { computed, defineComponent, ref, watch } from '~/utils/nuxt3-migration'
import { useI18n } from '~/compositions/i18n'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { useNamespacedStore } from '~/compositions/store'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { Searchable } from '~/models/search/types'

export default defineComponent({
  components: { CCustomSelect },
  props: facetHandlerComponentProps,
  setup(props) {
    const { changeParam } = useClassifiedSearchFacet()
    const { t } = useI18n()
    const { state: classifiedSearchState } = useNamespacedStore<SearchState>(
      CLASSIFIED_SEARCH_NS
    )

    const selectedValue = ref(props.selected?.low || null)

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    const googleRatings = computed(() => {
      if (props.searchables?.ranges) {
        return props.searchables.ranges
          .map((r: any) => {
            const hasHalfStar = r.v.match(/\./)
            const starsWithoutSymbol = r.v.replace('>', '')
            const stars = Math.round(parseInt(starsWithoutSymbol))

            return {
              label: `${t('from')} ${starsWithoutSymbol}`,
              stars,
              hasHalfStar,
              value: r.v,
              count: r.c
            }
          })
          .reverse()
      }
    })

    const options = computed(() => [
      {
        value: null,
        label: t('all')
      },
      ...(props.searchables?.ranges || []).map((s: Searchable) => ({
        value: s.low,
        label: s.n,
        count: s.c
      }))
    ])

    watch(
      () => props.selected,
      newValue => {
        selectedValue.value = newValue?.low || null
      }
    )

    function onClear() {
      changeParam({
        name: props.urlArgNames[0],
        value: null
      })
    }

    function onChange(value: string) {
      changeParam({
        name: props.urlArgNames[0],
        value: value ? `>${value}` : null
      })
    }

    return {
      loadingFacets,
      options,
      googleRatings,
      selectedValue,
      onChange,
      onClear
    }
  }
})
